export default "__VITE_ASSET__DtYC7MG0__"